import { withDefaultNavigation } from '@eig-builder/module-navigation'
import ParentTabsRouteWrapper from '@eig-builder/module-navigation/wrappers/parent-tabs-route-wrapper'

import { MANAGE } from '@eig-builder/core-utils/analytics/page-types'
import { NONE } from '@eig-builder/core-utils/analytics/flow-types'

import { ROLES } from '../crm/helpers/role-management/role-mapping'

const reportsRoute = brand => {
  return {
    component: ParentTabsRouteWrapper,
    path: `/financial-reports/${brand}`,
    documentTitle: 'Financial Reports',
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Overview',
        path: '/financial-reports/:brand/overview',
        location: () => `/financial-reports/${brand}/overview`,
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Sales',
        path: '/financial-reports/:brand/sales',
        location: () => `/financial-reports/${brand}/sales`,
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Flash Cash',
        path: '/financial-reports/:brand/flash',
        location: () => `/financial-reports/${brand}/flash`,
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Affiliates',
        path: '/financial-reports/:brand/affiliates',
        location: () => `/financial-reports/${brand}/affiliates`,
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Today',
        path: '/financial-reports/:brand/today',
        location: () => `/financial-reports/${brand}/today`,
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'GT Reports',
        path: '/financial-reports/:brand/gt-reports',
        location: () => `/financial-reports/${brand}/gt-reports`,
        component: () => import('./modules/download')
      },
      {
        title: 'Traffic Source',
        path: '/financial-reports/:brand/traffic-source',
        location: () => `/financial-reports/${brand}/traffic-source`,
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Active Subscribers',
        path: '/financial-reports/:brand/active-subscribers',
        location: () => `/financial-reports/${brand}/active-subscribers`,
        component: () => import('./modules/pages/reports/routes')
      }
    ]
  }
}

const Routes = [
  {
    component: ParentTabsRouteWrapper,
    path: '/financial-reports/wordpress-editor',
    documentTitle: 'Financial Reports - Wordpress Editor',
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Overview',
        path: '/financial-reports/:brand/overview',
        location: () => '/financial-reports/wordpress-editor/overview',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'New/Published Sites',
        path: '/financial-reports/:brand/published',
        location: () => '/financial-reports/wordpress-editor/published',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Usage',
        path: '/financial-reports/:brand/usage',
        location: () => '/financial-reports/wordpress-editor/usage',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Satisfaction',
        path: '/financial-reports/:brand/satisfaction',
        location: () => '/financial-reports/wordpress-editor/satisfaction',
        component: () => import('./modules/pages/reports/routes')
      }
      // {
      //   title: 'Today',
      //   path: '/financial-reports/:brand/today',
      //   location: () => '/financial-reports/wordpress-editor/today',
      //   component: () => import('./modules/pages/reports/routes')
      // }
    ]
  },
  {
    component: ParentTabsRouteWrapper,
    path: '/financial-reports/wordpress-cm',
    documentTitle: 'Financial Reports - Wordpress CM',
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Overview',
        path: '/financial-reports/:brand/overview',
        location: () => '/financial-reports/wordpress-cm/overview',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Screenshots',
        path: '/financial-reports/:brand/screenshots',
        location: () => '/financial-reports/wordpress-cm/screenshots',
        component: () => import('./modules/creative-email/screenshots')
      },
      {
        title: 'Sales',
        path: '/financial-reports/:brand/sales',
        location: () => '/financial-reports/wordpress-cm/sales',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Satisfaction',
        path: '/financial-reports/:brand/satisfaction',
        location: () => '/financial-reports/wordpress-cm/satisfaction',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Today',
        path: '/financial-reports/:brand/today',
        location: () => '/financial-reports/wordpress-cm/today',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Usage',
        path: '/financial-reports/:brand/usage',
        location: () => '/financial-reports/wordpress-cm/usage',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Advanced',
        path: '/financial-reports/:brand/advanced',
        location: () => '/financial-reports/wordpress-cm/advanced',
        component: () => import('./modules/pages/reports/routes')
      }
    ],
    requiredRole: [ROLES.ADMIN_MP, ROLES.BETA, ROLES.CREATIVE_EMAIL]
  },
  {
    ...reportsRoute('builder'),
    pageTitle: 'Management Portal - Financial Reports Builder',
    pattern: '/financial-reports/builder/:subpage',
    requiredRole: [
      ROLES.ADMIN_MP,
      ROLES.FINANCIAL,
      ROLES.BRAND_CONSTANTCONTACT,
      ROLES.BRAND_SINGLEPLATFORM,
      ROLES.BRAND_HOSTING,
      ROLES.BRAND_SITEBUILDER,
      ROLES.BRAND_SITELIO,
      ROLES.BRAND_SITEY,
      ROLES.BRAND_WEBSITEBUILDER
    ]
  },
  {
    ...reportsRoute('gator'),
    requiredRole: [ROLES.ADMIN_MP, ROLES.FINANCIAL, ROLES.BRAND_GATOR]
  },
  {
    component: ParentTabsRouteWrapper,
    path: '/financial-reports/ctct',
    documentTitle: 'Financial Reports',
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Overview',
        path: '/financial-reports/:brand/overview',
        location: () => '/financial-reports/ctct/overview',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Sales',
        path: '/financial-reports/:brand/sales',
        location: () => '/financial-reports/ctct/sales',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Flash Cash',
        path: '/financial-reports/:brand/flash',
        location: () => '/financial-reports/ctct/flash',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Affiliates',
        path: '/financial-reports/:brand/affiliates',
        location: () => '/financial-reports/ctct/affiliates',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Today',
        path: '/financial-reports/:brand/today',
        location: () => '/financial-reports/ctct/today',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'GT Reports',
        path: '/financial-reports/:brand/gt-reports',
        location: () => '/financial-reports/ctct/gt-reports',
        component: () => import('./modules/download')
      },
      {
        title: 'Traffic Source',
        path: '/financial-reports/:brand/traffic-source',
        location: () => '/financial-reports/ctct/traffic-source',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Active Subscribers',
        path: '/financial-reports/:brand/active-subscribers',
        location: () => `/financial-reports/ctct/active-subscribers`,
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'V2',
        path: '/financial-reports/:brand/v2',
        location: () => `/financial-reports/ctct/v2`,
        component: () => import('./modules/pages/reports/routes')
      }
    ],
    requiredRole: [ROLES.ADMIN_MP, ROLES.FINANCIAL, ROLES.BRAND_CONSTANTCONTACT]
  },
  {
    component: ParentTabsRouteWrapper,
    path: '/financial-reports/email-marketing',
    documentTitle: 'Financial Reports - Creativ.email',
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Overview',
        path: '/financial-reports/:brand/overview',
        location: () => '/financial-reports/email-marketing/overview',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Screenshots',
        path: '/financial-reports/:brand/screenshots',
        location: () => '/financial-reports/email-marketing/screenshots',
        component: () => import('./modules/creative-email/screenshots')
      },
      {
        title: 'Sales',
        path: '/financial-reports/:brand/sales',
        location: () => '/financial-reports/email-marketing/sales',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Satisfaction',
        path: '/financial-reports/:brand/satisfaction',
        location: () => '/financial-reports/email-marketing/satisfaction',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Usage',
        path: '/financial-reports/:brand/usage',
        location: () => '/financial-reports/email-marketing/usage',
        component: () => import('./modules/pages/reports/routes')
      }
    ],
    requiredRole: [/* ROLES.ADMIN_MP */ROLES.BETA, ROLES.CREATIVE_EMAIL]
  },
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Management Portal - Financial Reports Store',
    path: '/financial-reports/store',
    requiredRole: [ROLES.ADMIN_MP, ROLES.STORE],
    documentTitle: 'Financial Reports',
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Overview',
        path: '/financial-reports/store/overview',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'New Stores',
        path: '/financial-reports/store/newstores',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Orders/Sales',
        path: '/financial-reports/store/orders-sales',
        component: () => import('./modules/pages/reports/routes')
      }
    ]
  },
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Management Portal - Site Reports',
    documentTitle: 'Site Reports',
    path: '/financial-reports/site',
    requiredRole: [ROLES.ADMIN_MP, ROLES.ANALYTICS],
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'Overview',
        path: '/financial-reports/site/overview',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'New/Published Sites',
        path: '/financial-reports/site/published',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Traffic',
        path: '/financial-reports/site/traffic',
        component: () => import('./modules/pages/reports/routes')
      },
      {
        title: 'Satisfaction',
        path: '/financial-reports/site/nps',
        component: () => import('./modules/pages/reports/routes')
      }
    ]
  },
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Management Portal - Advanced Reports',
    documentTitle: 'Advanced Reports',
    path: '/financial-reports/advanced',
    requiredRole: [ROLES.ADMIN_MP, ROLES.ANALYTICS],
    pageType: MANAGE,
    flowType: NONE,
    subPages:
    // process.env.NODE_ENV === 'development'
    //   ? [
    //     {
    //       title: 'Express Editor',
    //       path: '/financial-reports/advanced/express',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'Constant Contact',
    //       path: '/financial-reports/advanced/ctct',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'LogoMaker',
    //       path: '/financial-reports/advanced/logomaker',
    //       component: () => import('./modules/logomaker')
    //     },
    //     {
    //       title: 'Blog',
    //       path: '/financial-reports/advanced/blog',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'Bookings',
    //       path: '/financial-reports/advanced/bookings',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'Verticals',
    //       path: '/financial-reports/advanced/verticals',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'Contact Sync',
    //       path: '/financial-reports/advanced/contact-sync',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'NGS / Overdue',
    //       path: '/financial-reports/advanced/ngs',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'PayPal UK-US',
    //       path: '/financial-reports/advanced/paypal',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'Transcript Analyzer',
    //       path: '/financial-reports/advanced/transcripts',
    //       component: () => import('./modules/pages/reports/routes')
    //     },
    //     {
    //       title: 'Karv Services',
    //       path: '/financial-reports/advanced/prof-services',
    //       component: () => import('./modules/pages/reports/routes')
    //     }
    //   ]
    //   :
        [
          {
            title: 'Express Editor',
            path: '/financial-reports/advanced/express',
            component: () => import('./modules/pages/reports/routes')
          },
          {
            title: 'Constant Contact',
            path: '/financial-reports/advanced/ctct',
            component: () => import('./modules/pages/reports/routes')
          },
          {
            title: 'LogoMaker',
            path: '/financial-reports/advanced/logomaker',
            component: () => import('./modules/logomaker')
          },
          {
            title: 'Blog',
            path: '/financial-reports/advanced/blog',
            component: () => import('./modules/pages/reports/routes')
          },
          {
            title: 'Bookings',
            path: '/financial-reports/advanced/bookings',
            component: () => import('./modules/pages/reports/routes')
          },
          {
            title: 'Verticals',
            path: '/financial-reports/advanced/verticals',
            component: () => import('./modules/pages/reports/routes')
          }
          // {
          //   title: 'Contact Sync',
          //   path: '/financial-reports/advanced/contact-sync',
          //   component: () => import('./modules/pages/reports/routes')
          // },
          // {
          //   title: 'Transcript Analyzer',
          //   path: '/financial-reports/advanced/transcripts',
          //   component: () => import('./modules/pages/reports/routes')
          // },
        ]
  },
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Management Portal - Social',
    documentTitle: 'Social',
    path: '/financial-reports/social',
    requiredRole: [ROLES.ADMIN_MP, ROLES.ANALYTICS],
    pageType: MANAGE,
    flowType: NONE,
    subPages: [
      {
        title: 'GMB Verifications',
        path: '/financial-reports/social/overview',
        component: () => import('./modules/pages/reports/routes')
      }
    ]
  },
  {
    component: withDefaultNavigation(() => import('./modules/configuration/containers/topics-page-container')),
    pageTitle: 'Management Portal - Configuration - Topics',
    documentTitle: 'Configuration - Topics',
    path: '/configuration/topic',
    requiredRole: [ROLES.BETA, ROLES.ADMIN_CST, ROLES.ADMIN_MP, ROLES.DEV_ADMIN],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: withDefaultNavigation(() => import('./modules/sift-report-tool')),
    pageTitle: 'Management Portal - Sift Report Tool',
    documentTitle: 'Management Portal - Sift Report Tool',
    path: '/sift-report-tool',
    requiredRole: [ROLES.ADMIN_CST, ROLES.DEV_ADMIN, ROLES.FAAS],
    pageType: MANAGE,
    flowType: NONE
  },
  {
    component: ParentTabsRouteWrapper,
    pageTitle: 'Management Portal - Support Team Reports',
    documentTitle: 'Support Team Reports',
    path: '/support-team-reports',
    subPages: [
      {
        title: 'PaaS Recycle Queue',
        path: '/support-team-reports/paas-recycle-queue',
        component: () => import('./modules/paas-recycle-queue')
      },
      {
        title: 'COVID-19 Postponed Renewals',
        path: '/support-team-reports/covid-19-postponed-renewals',
        component: () => import('./modules/covid-19-postponed-renewals')
      }
    ],
    requiredRole: [ROLES.ADMIN_CST, ROLES.SUPPORT],
    pageType: MANAGE,
    flowType: NONE
  }
]

export default Routes
